import { capture } from "./capture";

export const ExplorerTracking = {
  /** Status assigned to an opportunity. */
  opportunityStatusAssigned: (opportunityId: string, status: string) => {
    capture("explorer.opportunity_status_assigned", {
      opportunity_id: opportunityId,
      status,
    });
  },

  /** Owner assigned to an opportunity. */
  opportunityOwnerAssigned: (opportunityId: string, ownerId: string) => {
    capture("explorer.opportunity_owner_assigned", {
      opportunity_id: opportunityId,
      owner_id: ownerId,
    });
  },

  /** Bulk action performed on multiple opportunities. */
  bulkActionPerformed: (action: string, count: number) => {
    capture("explorer.bulk_action_performed", { action, count });
  },
};
